// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"InterruptProcessModal_modalContainer__1E2XH","stickyFooter":"InterruptProcessModal_stickyFooter__38GOi","modalContent":"InterruptProcessModal_modalContent__15J9u"};